import * as React from 'react'

interface IProps {
    visibleChildKey: string
    children: React.ReactElement<React.Props<any>>[]
}

export default class Sidebar extends React.Component<IProps> {

    render() {

        return (
            <React.Fragment>
                {this.props.children.map(this.renderChild)}
            </React.Fragment>
        )
    }

    renderChild = (child: React.ReactElement<React.Props<any>>, index: number) => {
        const divClassName = 'seatmap-content-info ' + 'sidebar-' + index + (child && child.key === this.props.visibleChildKey ? ' filters-open' : '')
        return (
            <div key={index} className={divClassName}>
                {child}
            </div>    
        )

    }
}